module.exports = __webpack_public_path__ + "static/media/48 - Mtume - Juicy Fruit.ba334a86.mp3";